import { forwardRef } from "react";

import LoadingButton from "@mui/lab/LoadingButton";
import InputAdornment from "@mui/material/InputAdornment";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import { FormHelperTextProps } from "@mui/material/FormHelperText";

type TextFieldWithLoadingButtonProps = {
  id?: string;
  value?: string | number;
  type?: string;
  placeholder?: string;
  disabled?: boolean;
  readOnly?: boolean;
  error?: boolean;
  helperText?: string;
  buttonLoading?: boolean;
  buttonText: string;
  buttonDisabled?: boolean;
  onClickButton?: () => void;
  label?: string;
  FormHelperTextProps?: FormHelperTextProps;
} & TextFieldProps;

// eslint-disable-next-line react/display-name
const TextFieldWithLoadingButton = forwardRef<
  HTMLInputElement,
  TextFieldWithLoadingButtonProps
>(
  (
    {
      id,
      type,
      placeholder,
      disabled,
      readOnly,
      error,
      helperText,
      buttonLoading,
      buttonText,
      buttonDisabled,
      onClickButton,
      label,
      FormHelperTextProps,
      ...inputProps
    },
    inputRef
  ) => {
    return (
      <TextField
        id={id}
        type={type}
        ref={inputRef}
        placeholder={placeholder}
        disabled={disabled}
        error={error}
        helperText={helperText}
        label={label}
        FormHelperTextProps={FormHelperTextProps}
        sx={{ pointerEvents: readOnly ? "none" : "auto" }}
        InputProps={{
          readOnly: readOnly,
          endAdornment: (
            <InputAdornment position="end">
              <LoadingButton
                loading={buttonLoading}
                disabled={buttonDisabled}
                onClick={onClickButton}
                variant="contained"
                size="small"
                sx={{
                  whiteSpace: "nowrap",
                  pointerEvents: "auto",
                }}
              >
                {buttonText}
              </LoadingButton>
            </InputAdornment>
          ),
        }}
        {...inputProps}
        autoComplete="off"
        fullWidth
      />
    );
  }
);

export default TextFieldWithLoadingButton;
